import {createContext} from 'preact';

import type {I18nProviderValue} from './types';

export const SUPPORTED_LOCALES = [
  'en',
  'bg',
  'bg-BG',
  'cs',
  'da',
  'de',
  'el',
  'es',
  'fi',
  'fr',
  'hi',
  'hr',
  'hr-HR',
  'hu',
  'id',
  'it',
  'ja',
  'ko',
  'lt',
  'lt-LT',
  'ms',
  'nb',
  'nl',
  'pl',
  'pt-BR',
  'pt-PT',
  'ro',
  'ro-RO',
  'ru',
  'sk',
  'sk-SK',
  'sl',
  'sl-SI',
  'sv',
  'th',
  'tr',
  'vi',
  'zh-CN',
  'zh-TW',
] as const;

const DEFAULT_CONTEXT_VALUE: I18nProviderValue = {
  loading: undefined,
  locale: 'en',
  translations: undefined,
};

export const I18nContext = createContext<I18nProviderValue>(
  DEFAULT_CONTEXT_VALUE,
);
